<template>
    <div class="tc pt3 legal mid-gray">
        <div>Request will be automatically cancelled in</div>
        <div class="b">{{timeRemaining}}</div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            timeRemaining: '03:34:14'
        };
    }
};
</script>
